export const appName = "911win Casino";
export const globalLink = "https://www.911win.co/";
